import React from "react";

interface MenuStackIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const MenuStackIcon: React.FC<MenuStackIconProps> = ({ size = 26, color = 'currentColor', className, onClick }) => (
  <svg width={size} height={size} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.0959 3.16343L20.4876 6.00176C22.3293 6.81426 22.3293 8.15759 20.4876 8.97009L14.0959 11.8084C13.3701 12.1334 12.1784 12.1334 11.4526 11.8084L5.06094 8.97009C3.21927 8.15759 3.21927 6.81426 5.06094 6.00176L11.4526 3.16343C12.1784 2.83843 13.3701 2.83843 14.0959 3.16343Z" stroke={color} strokeWidth="1.625" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3.25 11.9166C3.25 12.8266 3.9325 13.8775 4.76667 14.2458L12.1225 17.5175C12.6858 17.7666 13.325 17.7666 13.8775 17.5175L21.2333 14.2458C22.0675 13.8775 22.75 12.8266 22.75 11.9166" stroke={color} strokeWidth="1.625" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3.25 17.3334C3.25 18.3409 3.84583 19.2509 4.76667 19.6625L12.1225 22.9342C12.6858 23.1834 13.325 23.1834 13.8775 22.9342L21.2333 19.6625C22.1542 19.2509 22.75 18.3409 22.75 17.3334" stroke={color} strokeWidth="1.625" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default MenuStackIcon;
